import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { graph } from '@adc/constants';
import { formatTitleCase } from '../../../utils/formatters';
import { Label, Dropdown } from 'semantic-ui-react';
import { ColorHash } from '../../../utils';
const { enums } = graph;
export const convertGraphEnumToOptions = graphEnum => Object.values(graphEnum).map(val => ({
    text: formatTitleCase(val),
    value: val,
}));
const photoTagOptions = [
    { text: 'No Tag', value: '' },
    ...convertGraphEnumToOptions(enums.PropertyPhotoTag),
];
const colorHash = new ColorHash();
const TagDropdown = ({ tag, elmId, size, onTagChange, ...props }) => {
    const [label, setLabel] = useState(tag);
    const { disabled } = props;
    const trigger = (_jsx(Label, { size: size, style: {
            backgroundColor: label && !disabled ? colorHash.hex(label) : '#5c676e',
            color: '#fff',
            fontWeight: '700',
        }, content: formatTitleCase(label) || 'Click to Tag', tag: true }));
    const onChange = useCallback((e, data) => {
        onTagChange(data.value);
        setLabel(data.value);
    }, [label]);
    return (_jsx(Dropdown, { trigger: trigger, icon: null, "data-elm-id": elmId, onChange: onChange, value: label, options: photoTagOptions, disabled: disabled, ...props }));
};
TagDropdown.propTypes = {
    tag: PropTypes.string,
    size: PropTypes.oneOf([
        'mini',
        'tiny',
        'small',
        'medium',
        'large',
        'big',
        'huge',
        'massive',
    ]),
    elmId: PropTypes.string,
    ...Dropdown.PropTypes,
};
TagDropdown.defaultProps = {
    tag: '',
    size: 'mini',
    onTagChange: () => { },
    elmId: 'tag_dropdown',
};
export default TagDropdown;
//# sourceMappingURL=index.js.map